export const CREATE_DEPARTMENT = {
    REQUEST:"CREATE_DEPARTMENT_REQUEST",
    SUCCESS:"CREATE_DEPARTMENT_SUCCESS",
    FAIL:"CREATE_DEPARTMENT_FAIL",
}


export const GET_DEPARTMENTS = {
    REQUEST:"GET_DEPARTMENTS_REQUEST",
    SUCCESS:"GET_DEPARTMENTS_SUCCESS",
    FAIL:"GET_DEPARTMENTS_FAIL",
}

export const DELETE_DEPARTMENT = {
    REQUEST:"DELETE_DEPARTMENT_REQUEST",
    SUCCESS:"DELETE_DEPARTMENT_SUCCESS",
    FAIL:"DELETE_DEPARTMENT_FAIL",
}